import {
  Accordion as AccordionRCL,
  List as ListRCL,
} from "discover.medical.react-component-library";
import styled from "styled-components";

export const Accordion = styled(AccordionRCL)`
  width: 100%;
  color: ${({ theme }) => theme.colors.gray700};
  max-width: 923px;
`;

export const List = styled(ListRCL)`
  column-count: 1;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    column-count: ${({ columns }) => columns};
  }
`;
